import { render } from "./ArchiveMonosAgence.vue?vue&type=template&id=36bcb5f5&scoped=true"
import script from "./ArchiveMonosAgence.vue?vue&type=script&lang=js"
export * from "./ArchiveMonosAgence.vue?vue&type=script&lang=js"

import "./ArchiveMonosAgence.vue?vue&type=style&index=0&id=36bcb5f5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bcb5f5"]])

export default __exports__